import { SxProps } from '@mui/material';

export const helperTextStyles: SxProps = {
  display: 'block',
  mt: 1,
};

export const sectionLabelStyles: SxProps = {
  display: 'block',
  mb: 0.5,
  fontWeight: 700,
  letterSpacing: '0.08em',
};
